import { Grid, ButtonGroup } from 'components/ui';
import { WhiteCard } from 'components/styles_components/card';
import { CardTitleTypography } from 'components/styles_components/typography';
import EditButton from 'components/space/button/edit';

const ShowItem = ({ space, refetch }) => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <WhiteCard
          style={{ height: '100%', margin: 0, boxSizing: 'border-box', width: '100%' }}
        >
          <CardTitleTypography variant="h5">
            {space.name}
          </CardTitleTypography>
          <ButtonGroup>
            <EditButton space={space} refetch={refetch} />
          </ButtonGroup>
        </WhiteCard>
      </Grid>
    </Grid>
  );
};

export default ShowItem;
